import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./authSlice";
import bannerReducer from "./bannerSlice";
import campusReducer from "./campusSlice";
import careerReducer from "./careerSlice";
import jobfairReducer from "./jobfairSlice";
import jobReducer from "./jobSlice";
import notificationReducer from "./notificationSlice";
import recruitmentListReducer from "./recruitmentListSlice";
import topicReducer from "./topicSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    banner: bannerReducer,
    campus: campusReducer,
    job: jobReducer,
    notification: notificationReducer,
    topic: topicReducer,
    jobfair: jobfairReducer,
    career: careerReducer,
    recruitmentList: recruitmentListReducer,
  },
});
